import { ResponsiveContainer } from '@arpeggi/ui'
import { useRef } from 'react'
import { Autoplay, Mousewheel, Navigation } from 'swiper'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { styled } from '../../../../lib/stitches'
import { useNews } from '../../../../queries/news'
import { ChevronLeft, ChevronRight } from '../../../core/icons'
import Skeleton from '../../../core/Skeleton'
import { NewsItem } from '../../../platform/dashboard/news/NewsItem'

const Root = styled('div', {
  overflow: 'hidden'
})

const CarouselContainer = styled('div', {
  padding: '16px 32px',
  '@tablet': {
    padding: '16px 48px'
  }
})

const StyledNavigation = styled('div', {
  position: 'absolute',
  top: '50%',
  backgroundColor: '#FFFFFF',
  borderRadius: '50%',
  height: '32px',
  width: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background-color 0.15s ease',
  '&.swiper-button-disabled': {
    display: 'none'
  },
  '&:hover': {
    backgroundColor: '$gray04',
    cursor: 'pointer'
  }
})

const StyledPrevNavigation = styled(StyledNavigation, {
  left: '10px',
  transform: 'translate(0,-50%)',
  zIndex: 10
})

const StyledNextNavigation = styled(StyledNavigation, {
  right: '10px',
  transform: 'translate(0,-50%)',
  zIndex: 10
})

const chevronDimension = '20px'

const StyledChevronLeft = styled(ChevronLeft, {
  height: chevronDimension,
  width: chevronDimension
})

const StyledChevronRight = styled(ChevronRight, {
  height: chevronDimension,
  width: chevronDimension
})

export const News = () => {
  const newsQuery = useNews({ perPage: 1000, order: 'desc' })
  const prevRef = useRef(null)
  const nextRef = useRef(null)

  return (
    <ResponsiveContainer css={{ paddingTop: '16px', paddingBottom: '16px' }}>
      <Root>
        <Swiper
          navigation
          modules={[Navigation, Autoplay, Mousewheel]}
          spaceBetween={24}
          slidesPerView={1}
          breakpoints={{
            650: {
              slidesPerView: 2
            },
            1032: {
              slidesPerView: 2
            },
            1280: {
              slidesPerView: 3
            }
          }}
          style={{ overflow: 'inherit' }}
          onInit={(swiper) => {
            // @ts-ignore
            swiper.params.navigation.prevEl = prevRef.current
            // @ts-ignore
            swiper.params.navigation.nextEl = nextRef.current
            swiper.navigation.init()
            swiper.navigation.update()
          }}
        >
          <StyledPrevNavigation ref={prevRef}>
            <StyledChevronLeft />
          </StyledPrevNavigation>
          <StyledNextNavigation ref={nextRef}>
            <StyledChevronRight />
          </StyledNextNavigation>
          {newsQuery.isLoading &&
            [...Array(4)].map((_, index) => (
              <SwiperSlide key={index}>
                <Skeleton css={{ aspectRatio: 3 / 2, borderRadius: '$10' }} />
              </SwiperSlide>
            ))}
          {newsQuery.data &&
            newsQuery.data.pages.map((page) =>
              page.data.map((news) => (
                <SwiperSlide key={news.id}>
                  <NewsItem news={news} />
                </SwiperSlide>
              ))
            )}
        </Swiper>
      </Root>
    </ResponsiveContainer>
  )
}
